export const channelByUser = async (props) => {
  const { client, setActiveChannel, user } = props;
  const _userId = user?.id ?? client.user.id;

  const filters = {
    type: 'messaging',
    member_count: 2,
    members: { $eq: [_userId, client.userID || ''] },
  };

  const [existingChannel] = await client.queryChannels(filters);

  if (existingChannel) {
    return setActiveChannel(existingChannel);
  }

  const newChannel = client.channel('messaging', {
    members: [_userId, client.userID || ''],
    user: user,
    roomType: 'single',
  });
  return setActiveChannel(newChannel);
};
